import _ from "lodash";

import { ListProcessJobsParams } from "../api/processJobs.api";

//All Job Available to show on the api issue management page
export const apiIssueManagementJobs = [
  "api-import-bulk-order",
  "api-import-customer",
  "api-import-prices",
  "api-import-product-approval",
  "api-import-product",
  "api-import-bulk-invoice"
];

//All Job Available to show on the Jobs Queue page
export const categorisedProcessJobs = {
  /// Jobs which maintain the main functionality of Mezze
  main: [
    "shutdown-cancel-orders",
    "product-status-update",
    "substitute-product",
    "product-replacement",
    "authorize-off-session-payments",
    "ensure-order-prices",
    "delist-product",
    "sync-list-prices",
    "extend-ongoing-schedules",
    "order-pattern",
    "product-quantity-warning",
    "run-sql-report",
    "connector-accept-orders",
    "connector-check-for-order-update",
    "connector-sync-existing-orders",
    "close-inactive-tickets",
    "auto-deactivate-branches"
  ],
  /// Imports
  import: [
    "import-branches",
    "import-customer-order-history",
    "import-customers",
    "import-file-customer",
    "import-file-nutrition",
    "import-file-order",
    "import-file-price",
    "import-file-product-approval",
    "import-file-product",
    "import-file-user",
    "import-products"
  ],
  /// Exports
  export: [
    "order-export",
    "customer-drops-export",
    "product-export",
    "price-export",
    "product-substitution-export",
    "export-job-errors",
    "nutrition-product-export",
    "customer-user-export",
    "pending-customers-export",
    "credit-export",
    "export-sales-ledger",
    "product-approval-export"
  ],

  /// Email and Reminder Jobs
  email: [
    "notify-concluding-lists",
    "payment-reminders",
    "order-draft-reminders",
    "order-reminders"
  ]
};

//Jobs that only super admins should see
const superAdminJobs = [
  "connector-accept-orders",
  "connector-check-for-order-update",
  "connector-sync-existing-orders",
  "auto-deactivate-branches",
  "close-inactive-tickets",
  "ensure-order-prices",
  "sync-list-prices",
  "extend-ongoing-schedules",
  "order-pattern"
];

export type ProcessJobCategories = typeof categorisedProcessJobs;

export const processJobCategories = Object.keys(categorisedProcessJobs) as Array<keyof ProcessJobCategories>;

//generates filters for tables.
export function filterHelper(jobNames: string[]): ListProcessJobsParams["filters"] {
  return { name: { $in: jobNames } };
}

//converts the category name to a title.
export function titleHelper(category: keyof ProcessJobCategories) {
  switch (category) {
    case "email":
      return "Email & Reminder Jobs";
    case "export":
      return "Export Jobs";
    case "import":
      return "Import Jobs";
    case "main":
      return "Main Jobs";
  }
}

//for use on building drop down table filters
export function optionsHelper(jobNames: string[]): Array<{
  text: string;
  value: string;
}> {
  jobNames.sort();

  return jobNames.map(job => {
    const humanReadableName = job.split("-").map(word => {
      return _.startCase(word);
    }
    ).join(" ");

    return {
      text: humanReadableName,
      value: job
    };
  });
}

export function filterOutSuperAdminJobs(jobNames: string[]) {
  return jobNames.filter(job => !superAdminJobs.includes(job));
}